import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import { Nav } from '../common/Layout'
import DefaultNav from '../common/DefaultNav'
import { selectUserLocationId } from '../../redux/modules/selectors'

import { Link } from 'react-scroll'

export const OrderNavMenuSectionListItem = ({ id, name }) => (
  <li>
    <Link to={id} smooth spy>
      {name}
    </Link>
  </li>
)

export const OrderNavMenuSectionList = ({ sections, showPastAndPopular }) => {
  let sectionListItems = null

  if (sections && sections instanceof Array) {
    sectionListItems = sections.map(({ id, name }) => (
      <OrderNavMenuSectionListItem key={id} id={id} name={name} />
    ))
  }

  return (
    <ul>
      {/* static portion of the nav */}
      <li>Options</li>
      {showPastAndPopular && (
        <Fragment>
          <OrderNavMenuSectionListItem id="pastorders" name="Past Orders" />
          <OrderNavMenuSectionListItem id="popularitems" name="Popular Items" />
        </Fragment>
      )}
      {/* dynamic portion of nav based on menu sections */}
      {sectionListItems}
    </ul>
  )
}

export class OrderNav extends Component {
  render() {
    const { sections, match, isAuthenticated } = this.props
    let { locationId } = this.props
    if (locationId == null || locationId === '') {
      locationId = Number(match.params.locationId)
    }
    return (
      <Nav>
        <div className="sticky">
          <DefaultNav pageName="Place Order" locationId={locationId} />
          <OrderNavMenuSectionList
            sections={sections}
            showPastAndPopular={isAuthenticated}
          />
        </div>
      </Nav>
    )
  }
}

const mapStateToProps = state => {
  const { menu } = state.order
  const locationId = selectUserLocationId(state)
  const { isAuthenticated } = state.user
  // parse out the menu sections
  let sections = []
  if (menu && menu.subMenus) {
    sections = menu.subMenus.map(sub => {
      return {
        id: sub.id.toString(),
        name: sub.name
      }
    })
  }

  return {
    sections,
    locationId,
    isAuthenticated
  }
}

const mapDispatchToProps = {}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OrderNav)
